import { render, staticRenderFns } from "./CambiarTipoTareaModalComponent.vue?vue&type=template&id=a7aae9f4&"
import script from "./CambiarTipoTareaModalComponent.vue?vue&type=script&lang=js&"
export * from "./CambiarTipoTareaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports